<template lang="pug">
b-modal#sprite-detail(title='Sprite Summary', :hide-footer='true', @hide='onHide()')
  h3 {{ sprite.name }}
  div
    .row
      .col-12
        activity-list(:activity='sprite.recentActivity')
</template>

<style lang="scss">
  // @TODO: share
  #sprite-detail {
    .modal-content {
      border-radius: 16px;
      border: none;
    }

    .top-background {
      z-index: 0;
      top: -1px;
      left: 0;
      height: 150px;
      position: absolute;
      width: 100%;
      // height: 736px;
      background-position: center;
      background-size: 100%;
      background-repeat: no-repeat;
      background-image:
        image-set(
          url('../../assets/forest-background.png') 1x,
          url('../../assets/forest-background@2x.png') 2x,
          url('../../assets/forest-background@3x.png') 3x,
        );
    }

    .modal-dialog {
      // width: 588px;
      border-radius: 16px;
      background-color: #ffffff;

      .modal-header {
        border-radius: 16px 16px 0 0;
        background-image: linear-gradient(to right, #9bc75a, #3ba5a8);

        h5.modal-title {
          margin-left: 12em;
          text-align: center;
          text-transform: uppercase;
          font-size: 14px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.43;
          letter-spacing: 1px;
          text-align: center;
          color: #ffffff;
          // margin: 0 auto;
        }
      }

      button {
        color: #fff;
        opacity: 1;
        text-shadow: none;
      }
    }
  }
</style>

<style lang="scss" scoped>
  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    margin: 0 10px;
  }

  h5, h3 {
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: #a1a39e;
    text-transform: uppercase;
  }

  h3 {
    font-size: 20px;
  }

  h5 {
    font-size: 12px;
  }
</style>

<script>
import ActivityList from '../activity/ActivityList';

export default {
  components: {
    ActivityList,
  },
  data() {
    return {
      sprite: {},
    };
  },
  mounted() {
    this.$root.$on('show-sprite-detail', this.showSpriteDetail);
  },
  destroyed() {
    this.$root.$off('show-sprite-detail', this.showSpriteDetail);
  },
  methods: {
    showSpriteDetail(spriteData) {
      this.sprite = spriteData.sprite;
      this.$root.$emit('bv::show::modal', 'sprite-detail');
    },
    onHide() {
      this.$store.commit('setLastViewActivityForId', { id: this.sprite._id });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/monsters/SpriteDetail.vue